import * as AdsAudienceMembershipActionOperations from 'automation-ui-action-features/actions/ads-audience-membership/AdsAudienceMembershipActionOperations';
import * as AlterListMembershipActionOperations from 'automation-ui-action-features/actions/alter-list-membership/AlterListMembershipActionOperations';
import * as DelayActionSubTypes from 'automation-ui-action-features/actions/delay/constants/DelayActionSubTypes';
import * as SetPropertyActionOperations from 'automation-ui-action-features/actions/set-property/SetPropertyActionOperations';
import * as ActionTypeIds from 'automation-ui-action-features/constants/ActionTypeIds';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import ActionMetadata from 'automation-ui-action-features/records/ActionMetadata';
import ActionTypeBasePaths from 'automation-ui-routing/ActionTypeBasePaths';
export const CUSTOM_CODE = new ActionMetadata({
  type: ActionTypes.CUSTOM_CODE,
  typeId: ActionTypeIds.CUSTOM_CODE,
  actionTypeBasePath: ActionTypeBasePaths.PLATFORM_FLOW_CUSTOM_CODE_ACTION,
  description: 'automation-ui-action-features.action-features.custom-code.actionDescription',
  panelDescription: 'automation-ui-action-features.action-features.custom-code.panelDescription_cob',
  icon: 'code',
  theme: 'default',
  category: 'DATA_OPS',
  dataTestId: 'new-action-custom-code'
});
export const WHILE_LOOP = new ActionMetadata({
  type: ActionTypes.WHILE_LOOP,
  typeId: ActionTypeIds.WHILE_LOOP,
  actionTypeBasePath: ActionTypeBasePaths.PLATFORM_FLOW_WHILE_LOOP_ACTION,
  description: 'automation-ui-action-features.action-features.while-loop.description',
  icon: 'refresh',
  // TODO ZS: better icon?
  theme: 'default',
  category: 'QUICK_ACTIONS',
  dataTestId: 'new-action-while-loop'
});
export const DELAY_DURATION = new ActionMetadata({
  type: ActionTypes.DELAY,
  typeId: ActionTypeIds.DELAY,
  actionTypeBasePath: ActionTypeBasePaths.PLATFORM_FLOW_DELAY_ACTION,
  description: 'automation-ui-action-features.action-features.all-delays.description',
  groupDescription: 'automation-ui-action-features.action-features.delay.description',
  panelDescription: 'automation-ui-action-features.action-features.delay.DURATION.panelDescription_cob',
  icon: 'delay',
  theme: 'default',
  category: 'QUICK_ACTIONS',
  routeParams: {
    type: DelayActionSubTypes.DURATION
  },
  dataTestId: 'new-action-delay-duration'
});
export const DELAY_DAY_OR_TIME = new ActionMetadata({
  type: ActionTypes.DELAY,
  typeId: ActionTypeIds.DELAY,
  actionTypeBasePath: ActionTypeBasePaths.PLATFORM_FLOW_DELAY_ACTION,
  description: 'automation-ui-action-features.action-features.all-delays.description',
  groupDescription: 'automation-ui-action-features.action-features.delay.description',
  panelDescription: 'automation-ui-action-features.action-features.delay.DAY_OR_TIME.panelDescription_cob',
  icon: 'delay',
  theme: 'default',
  category: 'QUICK_ACTIONS',
  routeParams: {
    type: DelayActionSubTypes.DAY_OR_TIME
  },
  dataTestId: 'new-action-delay-day-or-time'
});
export const DELAY_DAY = new ActionMetadata({
  type: ActionTypes.DELAY,
  typeId: ActionTypeIds.DELAY,
  actionTypeBasePath: ActionTypeBasePaths.PLATFORM_FLOW_DELAY_ACTION,
  description: 'automation-ui-action-features.action-features.all-delays.description',
  groupDescription: 'automation-ui-action-features.action-features.delay.description',
  panelDescription: 'automation-ui-action-features.action-features.delay.DAY_OR_TIME.panelDescription_cob',
  icon: 'delay',
  theme: 'default',
  category: 'QUICK_ACTIONS',
  routeParams: {
    type: DelayActionSubTypes.DAY
  },
  dataTestId: 'new-action-delay-day'
});
export const DELAY_TIME = new ActionMetadata({
  type: ActionTypes.DELAY,
  typeId: ActionTypeIds.DELAY,
  actionTypeBasePath: ActionTypeBasePaths.PLATFORM_FLOW_DELAY_ACTION,
  description: 'automation-ui-action-features.action-features.all-delays.description',
  groupDescription: 'automation-ui-action-features.action-features.delay.description',
  panelDescription: 'automation-ui-action-features.action-features.delay.DAY_OR_TIME.panelDescription_cob',
  icon: 'delay',
  theme: 'default',
  category: 'QUICK_ACTIONS',
  routeParams: {
    type: DelayActionSubTypes.TIME
  },
  dataTestId: 'new-action-delay-time'
});
export const DELAY_UNTIL_DATE = new ActionMetadata({
  type: ActionTypes.DELAY_UNTIL_DATE,
  typeId: ActionTypeIds.DELAY_UNTIL_DATE,
  actionTypeBasePath: ActionTypeBasePaths.PLATFORM_FLOW_DELAY_UNTIL_DATE_ACTION,
  description: 'automation-ui-action-features.action-features.all-delays.description',
  panelDescription: 'automation-ui-action-features.action-features.delay-until-date.panelDescription_cob',
  icon: 'delay',
  theme: 'default',
  category: 'QUICK_ACTIONS',
  dataTestId: 'new-action-delay-until-date'
});
export const WAIT_UNTIL = new ActionMetadata({
  type: ActionTypes.WAIT_UNTIL,
  typeId: ActionTypeIds.WAIT_UNTIL,
  actionTypeBasePath: ActionTypeBasePaths.PLATFORM_FLOW_WAIT_UNTIL_ACTION,
  description: 'automation-ui-action-features.action-features.all-delays.description',
  panelDescription: 'automation-ui-action-features.action-features.wait-until.panelDescription_cob',
  icon: 'delay',
  theme: 'default',
  category: 'QUICK_ACTIONS',
  dataTestId: 'new-action-wait-until'
});
export const LIST_BRANCH = new ActionMetadata({
  type: ActionTypes.LIST_BRANCH,
  typeId: ActionTypeIds.LIST_BRANCH,
  actionTypeBasePath: ActionTypeBasePaths.PLATFORM_FLOW_LIST_BRANCH_ACTION,
  description: 'automation-ui-action-features.action-features.all-branches.description',
  panelDescription: 'automation-ui-action-features.action-features.list-branch.panelDescription_cob',
  icon: 'conditional',
  theme: 'default',
  category: 'QUICK_ACTIONS',
  dataTestId: 'new-action-list-branch'
});
export const STATIC_BRANCH = new ActionMetadata({
  type: ActionTypes.STATIC_BRANCH,
  typeId: ActionTypeIds.STATIC_BRANCH,
  actionTypeBasePath: ActionTypeBasePaths.PLATFORM_FLOW_STATIC_BRANCH_ACTION,
  description: 'automation-ui-action-features.action-features.all-branches.description',
  panelDescription: 'automation-ui-action-features.action-features.static-branch.panelDescription_cob',
  icon: 'conditional',
  theme: 'default',
  category: 'QUICK_ACTIONS',
  dataTestId: 'new-action-static-branch'
});
export const AB_TEST_BRANCH = new ActionMetadata({
  type: ActionTypes.AB_TEST_BRANCH,
  typeId: ActionTypeIds.AB_TEST_BRANCH,
  actionTypeBasePath: ActionTypeBasePaths.PLATFORM_FLOW_AB_TEST_BRANCH_ACTION,
  description: 'automation-ui-action-features.action-features.ab-test-branch.gatedDescription',
  panelDescription: 'automation-ui-action-features.action-features.ab-test-branch.panelDescription_cob',
  icon: 'conditional',
  theme: 'default',
  category: 'QUICK_ACTIONS',
  dataTestId: 'new-action-ab-test-branch'
});
export const GO_TO = new ActionMetadata({
  type: ActionTypes.GO_TO,
  actionTypeBasePath: ActionTypeBasePaths.PLATFORM_FLOW_GO_TO_ACTION,
  description: 'automation-ui-action-features.action-features.go-to.description',
  panelDescription: 'automation-ui-action-features.action-features.go-to.panelDescription_cob',
  icon: 'next',
  theme: 'default',
  category: 'QUICK_ACTIONS',
  dataTestId: 'new-action-go-to'
});
export const TASK = new ActionMetadata({
  type: ActionTypes.TASK,
  typeId: ActionTypeIds.TASK,
  actionTypeBasePath: ActionTypeBasePaths.PLATFORM_FLOW_TASK_ACTION,
  description: 'automation-ui-action-features.action-features.create-task.description',
  panelDescription: 'automation-ui-action-features.action-features.create-task.panelDescription_cob',
  icon: 'tasks',
  theme: 'sorbet',
  category: 'CRM',
  dataTestId: 'new-action-task'
});
export const EMAIL = new ActionMetadata({
  type: ActionTypes.EMAIL,
  typeId: ActionTypeIds.EMAIL,
  actionTypeBasePath: ActionTypeBasePaths.PLATFORM_FLOW_EMAIL_ACTION,
  description: 'automation-ui-action-features.action-features.email.description',
  panelDescription: 'automation-ui-action-features.action-features.email.panelDescription_cob',
  icon: 'email',
  theme: 'thunderdome',
  category: 'COMMUNICATIONS',
  dataTestId: 'new-action-email'
});
export const EMAIL_NOTIFICATION = new ActionMetadata({
  type: ActionTypes.EMAIL_NOTIFICATION,
  typeId: ActionTypeIds.EMAIL_NOTIFICATION,
  actionTypeBasePath: ActionTypeBasePaths.PLATFORM_FLOW_EMAIL_NOTIFICATION_ACTION,
  description: 'automation-ui-action-features.action-features.email-notification.description',
  panelDescription: 'automation-ui-action-features.action-features.email-notification.panelDescription_cob',
  icon: 'email',
  theme: 'oz',
  category: 'COMMUNICATIONS',
  dataTestId: 'new-action-email-notification'
});
export const CREATE_OBJECT = new ActionMetadata({
  type: ActionTypes.CREATE_OBJECT,
  typeId: ActionTypeIds.CREATE_OBJECT,
  actionTypeBasePath: ActionTypeBasePaths.PLATFORM_FLOW_CREATE_OBJECT_ACTION,
  description: 'automation-ui-action-features.action-features.create-object.description',
  panelDescription: 'automation-ui-action-features.action-features.create-object.panelDescription_cob',
  icon: 'customObject',
  theme: 'sorbet',
  category: 'CRM',
  dataTestId: 'new-action-create-object',
  updateKeyPaths: ['automation-ui-action-features.action-features.create-object.updates.line-items']
});
export const INCREASE_PROPERTY = new ActionMetadata({
  type: ActionTypes.SET_PROPERTY,
  typeId: ActionTypeIds.SET_PROPERTY,
  actionTypeBasePath: ActionTypeBasePaths.PLATFORM_FLOW_SET_PROPERTY_ACTION,
  description: 'automation-ui-action-features.action-features.set-property.INCREASE.description',
  groupDescription: 'automation-ui-action-features.action-features.set-property.description',
  panelDescription: 'automation-ui-action-features.action-features.set-property.INCREASE.panelDescription_cob',
  icon: 'switcher',
  theme: 'calypso',
  category: 'CRM',
  routeParams: {
    type: SetPropertyActionOperations.INCREASE
  },
  dataTestId: 'new-action-increase-property'
});
export const SET_PROPERTY = new ActionMetadata({
  type: ActionTypes.SET_PROPERTY,
  typeId: ActionTypeIds.SET_PROPERTY,
  actionTypeBasePath: ActionTypeBasePaths.PLATFORM_FLOW_SET_PROPERTY_ACTION,
  description: 'automation-ui-action-features.action-features.set-property.SET.description',
  groupDescription: 'automation-ui-action-features.action-features.set-property.description',
  panelDescription: 'automation-ui-action-features.action-features.set-property.SET.panelDescription_cob',
  icon: 'description',
  theme: 'calypso',
  category: 'CRM',
  routeParams: {
    type: SetPropertyActionOperations.SET
  },
  dataTestId: 'new-action-set-property'
});
export const SLACK_NOTIFICATION = new ActionMetadata({
  type: ActionTypes.SLACK_NOTIFICATION,
  typeId: ActionTypeIds.SLACK_NOTIFICATION,
  actionTypeBasePath: ActionTypeBasePaths.PLATFORM_FLOW_SLACK_NOTIFICATION_ACTION,
  description: 'automation-ui-action-features.action-features.slack.description',
  icon: 'socialSlack',
  theme: 'marigold',
  category: 'COMMUNICATIONS',
  dataTestId: 'new-action-slack-notification'
});
export const IN_APP_NOTIFICATION = new ActionMetadata({
  type: ActionTypes.IN_APP_NOTIFICATION,
  typeId: ActionTypeIds.IN_APP_NOTIFICATION,
  actionTypeBasePath: ActionTypeBasePaths.PLATFORM_FLOW_IN_APP_NOTIFICATION_ACTION,
  description: 'automation-ui-action-features.action-features.in-app-notification.description',
  panelDescription: 'automation-ui-action-features.action-features.in-app-notification.panelDescription_cob',
  icon: 'notification',
  theme: 'oz',
  category: 'COMMUNICATIONS',
  dataTestId: 'new-action-in-app-notification'
});
export const ENROLL_IN_FLOW = new ActionMetadata({
  type: ActionTypes.ENROLL_IN_FLOW,
  typeId: ActionTypeIds.ENROLL_IN_FLOW,
  actionTypeBasePath: ActionTypeBasePaths.PLATFORM_FLOW_ENROLL_IN_FLOW_ACTION,
  description: 'automation-ui-action-features.action-features.enroll-in-flow.description',
  panelDescription: 'automation-ui-action-features.action-features.enroll-in-flow.panelDescription_cob',
  icon: 'next',
  theme: 'default',
  category: 'QUICK_ACTIONS',
  dataTestId: 'new-action-enroll-in-flow'
});
export const ROTATE_OBJECT = new ActionMetadata({
  type: ActionTypes.ROTATE_OBJECT,
  typeId: ActionTypeIds.ROTATE_OBJECT,
  actionTypeBasePath: ActionTypeBasePaths.PLATFORM_FLOW_ROTATE_OBJECT_ACTION,
  description: 'automation-ui-action-features.action-features.rotate-object.description',
  panelDescription: 'automation-ui-action-features.action-features.rotate-object.panelDescription_cob',
  icon: 'rotateLeads',
  theme: 'norman',
  category: 'CRM',
  dataTestId: 'new-action-rotate-object'
});
export const ADD_TO_LIST = new ActionMetadata({
  type: ActionTypes.ALTER_LIST_MEMBERSHIP,
  typeId: ActionTypeIds.ALTER_LIST_MEMBERSHIP,
  actionTypeBasePath: ActionTypeBasePaths.PLATFORM_FLOW_ALTER_LIST_MEMBERSHIP_ACTION,
  description: 'automation-ui-action-features.action-features.alter-list-membership.description.add',
  groupDescription: 'automation-ui-action-features.action-features.alter-list-membership.description.default',
  panelDescription: 'automation-ui-action-features.action-features.alter-list-membership.panel-description.add_cob',
  icon: 'lists',
  theme: 'calypso',
  category: 'MARKETING',
  routeParams: {
    type: AlterListMembershipActionOperations.ADD
  },
  dataTestId: 'new-action-add-to-list'
});
export const REMOVE_FROM_LIST = new ActionMetadata({
  type: ActionTypes.ALTER_LIST_MEMBERSHIP,
  typeId: ActionTypeIds.ALTER_LIST_MEMBERSHIP,
  actionTypeBasePath: ActionTypeBasePaths.PLATFORM_FLOW_ALTER_LIST_MEMBERSHIP_ACTION,
  description: 'automation-ui-action-features.action-features.alter-list-membership.description.remove',
  groupDescription: 'automation-ui-action-features.action-features.alter-list-membership.description.default',
  panelDescription: 'automation-ui-action-features.action-features.alter-list-membership.panel-description.remove_cob',
  icon: 'lists',
  theme: 'calypso',
  category: 'MARKETING',
  routeParams: {
    type: AlterListMembershipActionOperations.REMOVE
  },
  dataTestId: 'new-action-remove-from-list'
});
export const WEBHOOK = new ActionMetadata({
  type: ActionTypes.WEBHOOK,
  typeId: ActionTypeIds.WEBHOOK,
  actionTypeBasePath: ActionTypeBasePaths.PLATFORM_FLOW_WEBHOOK_ACTION,
  description: 'automation-ui-action-features.action-features.webhook.description',
  panelDescription: 'automation-ui-action-features.action-features.webhook.panelDescription_cob',
  icon: 'integrations',
  theme: 'default',
  category: 'DATA_OPS',
  dataTestId: 'new-action-webhook'
});
export const SEND_SMS_NOTIFICATION = new ActionMetadata({
  type: ActionTypes.SEND_SMS_NOTIFICATION,
  typeId: ActionTypeIds.SEND_SMS_NOTIFICATION,
  actionTypeBasePath: ActionTypeBasePaths.PLATFORM_FLOW_SEND_SMS_NOTIFICATION_ACTION,
  description: 'automation-ui-action-features.action-features.send-internal-sms.description',
  icon: 'sms',
  theme: 'oz',
  category: 'COMMUNICATIONS',
  dataTestId: 'new-action-send-sms-notification'
});
export const CREATE_SALESFORCE_CAMPAIGN = new ActionMetadata({
  type: ActionTypes.CREATE_SALESFORCE_CAMPAIGN,
  typeId: ActionTypeIds.CREATE_SALESFORCE_CAMPAIGN,
  actionTypeBasePath: ActionTypeBasePaths.PLATFORM_FLOW_CREATE_SALESFORCE_CAMPAIGN_ACTION,
  description: 'automation-ui-action-features.action-features.create-salesforce-campaign.description',
  icon: 'integrationsSalesForce',
  theme: 'marigold',
  category: 'CRM',
  dataTestId: 'new-action-create-salesforce-campaign'
});
export const CREATE_SALESFORCE_TASK = new ActionMetadata({
  type: ActionTypes.CREATE_SALESFORCE_TASK,
  typeId: ActionTypeIds.CREATE_SALESFORCE_TASK,
  actionTypeBasePath: ActionTypeBasePaths.PLATFORM_FLOW_CREATE_SALESFORCE_TASK_ACTION,
  description: 'automation-ui-action-features.action-features.create-salesforce-task.description',
  icon: 'integrationsSalesForce',
  theme: 'marigold',
  category: 'CRM',
  dataTestId: 'new-action-create-salesforce-task'
});

/**
 * @deprecated Built-in action migrated to Actions API. Keeping around for
 * backwards compatibility.
 */
export const UPDATE_EMAIL_SUBSCRIPTION = new ActionMetadata({
  description: 'automation-ui-action-features.action-features.set-subscriptions.description'
});

/**
 * @deprecated Powered by CLS instead of ILS. Prefer ALTER_LIST_MEMBERSHIP.
 * Keeping around for backwards compatibility.
 */
export const CLASSIC_ADD_TO_LIST = new ActionMetadata({
  description: 'automation-ui-action-features.action-features.alter-list-membership.description.add'
});

/**
 * @deprecated Powered by CLS instead of ILS. Prefer ALTER_LIST_MEMBERSHIP.
 */
export const CLASSIC_REMOVE_FROM_LIST = new ActionMetadata({
  description: 'automation-ui-action-features.action-features.alter-list-membership.description.remove'
});
export const CLASSIC_COPY_COMPANY_PROPERTY = new ActionMetadata({
  type: ActionTypes.CLASSIC_COPY_COMPANY_PROPERTY,
  typeId: ActionTypeIds.CLASSIC_COPY_COMPANY_PROPERTY,
  actionTypeBasePath: ActionTypeBasePaths.PLATFORM_FLOW_CLASSIC_COPY_COMPANY_PROPERTY_ACTION,
  description: 'automation-ui-action-features.action-features.classic-copy-company-property.description',
  panelDescription: 'automation-ui-action-features.action-features.classic-copy-company-property.panelDescription_cob',
  icon: 'duplicate',
  theme: 'calypso',
  category: 'CRM',
  dataTestId: 'new-action-hybrid-copy-company-property'
});
export const CLASSIC_ENROLL_IN_WORKFLOW = new ActionMetadata({
  type: ActionTypes.CLASSIC_ENROLL_IN_WORKFLOW,
  typeId: ActionTypeIds.CLASSIC_ENROLL_IN_WORKFLOW,
  actionTypeBasePath: ActionTypeBasePaths.PLATFORM_FLOW_CLASSIC_ENROLL_IN_WORKFLOW_ACTION,
  description: 'automation-ui-action-features.action-features.classic-enroll-in-flow.description',
  panelDescription: 'automation-ui-action-features.action-features.classic-enroll-in-flow.panelDescription_cob',
  icon: 'next',
  theme: 'default',
  category: 'QUICK_ACTIONS',
  dataTestId: 'new-action-classic-enroll-in-flow'
});
export const CLASSIC_NOTIFICATION_EMAIL = new ActionMetadata({
  type: ActionTypes.CLASSIC_NOTIFICATION_EMAIL,
  typeId: ActionTypeIds.CLASSIC_NOTIFICATION_EMAIL,
  actionTypeBasePath: ActionTypeBasePaths.PLATFORM_FLOW_CLASSIC_NOTIFICATION_EMAIL_ACTION,
  description: 'automation-ui-action-features.action-features.classic-notification-email.description',
  panelDescription: 'automation-ui-action-features.action-features.classic-notification-email.panelDescription_cob',
  icon: 'email',
  theme: 'oz',
  category: 'COMMUNICATIONS',
  dataTestId: 'new-action-classic-notification-email'
});
export const CLASSIC_ANCHORED_DELAY = new ActionMetadata({
  type: ActionTypes.CLASSIC_ANCHORED_DELAY,
  typeId: ActionTypeIds.CLASSIC_ANCHORED_DELAY,
  actionTypeBasePath: ActionTypeBasePaths.PLATFORM_FLOW_CLASSIC_ANCHORED_DELAY_ACTION,
  description: 'automation-ui-action-features.action-features.classic-anchored-delay.description',
  icon: 'delay',
  theme: 'default',
  category: 'QUICK_ACTIONS',
  dataTestId: 'new-action-classic-anchored-delay'
});
export const CLASSIC_VIRTUAL_ANCHORED_DELAY = new ActionMetadata({
  type: ActionTypes.CLASSIC_VIRTUAL_ANCHORED_DELAY,
  actionTypeBasePath: ActionTypeBasePaths.PLATFORM_FLOW_CLASSIC_VIRTUAL_ANCHORED_DELAY_ACTION,
  description: 'automation-ui-action-features.action-features.classic-virtual-anchored-delay.description',
  icon: 'date',
  theme: 'default',
  category: 'QUICK_ACTIONS',
  dataTestId: 'new-action-classic-virtual-anchored-delay'
});
export const VIRTUAL_SCHEDULED_ENROLLMENT = new ActionMetadata({
  type: ActionTypes.VIRTUAL_SCHEDULED_ENROLLMENT,
  actionTypeBasePath: ActionTypeBasePaths.PLATFORM_FLOW_VIRTUAL_SCHEDULED_ENROLLMENT,
  description: 'automation-ui-action-features.action-features.virtual-scheduled-enrollment.description',
  icon: 'time',
  theme: 'default',
  category: 'QUICK_ACTIONS',
  dataTestId: 'new-action-virtual-scheduled-enrollment'
});
export const ADS_ADD_TO_AUDIENCE = new ActionMetadata({
  type: ActionTypes.ADS_AUDIENCE_MEMBERSHIP,
  typeId: ActionTypeIds.ADS_AUDIENCE_MEMBERSHIP,
  actionTypeBasePath: ActionTypeBasePaths.PLATFORM_FLOW_ADS_AUDIENCE_MEMBERSHIP_ACTION,
  description: 'automation-ui-action-features.action-features.ads-audience-membership.description.add',
  groupDescription: 'automation-ui-action-features.action-features.ads-audience-membership.description.default',
  panelDescription: 'automation-ui-action-features.action-features.ads-audience-membership.panel-description.add_cob',
  icon: 'audienceTargeting',
  theme: 'default',
  category: 'MARKETING',
  routeParams: {
    type: AdsAudienceMembershipActionOperations.ADD
  },
  dataTestId: 'new-action-add-to-audience'
});
export const ADS_REMOVE_FROM_AUDIENCE = new ActionMetadata({
  type: ActionTypes.ADS_AUDIENCE_MEMBERSHIP,
  typeId: ActionTypeIds.ADS_AUDIENCE_MEMBERSHIP,
  actionTypeBasePath: ActionTypeBasePaths.PLATFORM_FLOW_ADS_AUDIENCE_MEMBERSHIP_ACTION,
  description: 'automation-ui-action-features.action-features.ads-audience-membership.description.remove',
  groupDescription: 'automation-ui-action-features.action-features.ads-audience-membership.description.default',
  panelDescription: 'automation-ui-action-features.action-features.ads-audience-membership.panel-description.remove_cob',
  icon: 'audienceTargeting',
  theme: 'default',
  category: 'MARKETING',
  routeParams: {
    type: AdsAudienceMembershipActionOperations.REMOVE
  },
  dataTestId: 'new-action-remove-from-audience'
});

/**
 * @deprecated Keeping for backwards compatibility. Prefer the HubSpot-built
 *   Custom Action instead.
 */
export const SET_MARKETING_STATUS = new ActionMetadata({
  description: 'automation-ui-action-features.action-features.set-marketing-status.description'
});
export const FORMULA = new ActionMetadata({
  type: ActionTypes.FORMULA,
  typeId: ActionTypeIds.FORMULA,
  actionTypeBasePath: ActionTypeBasePaths.PLATFORM_FLOW_FORMULA_ACTION,
  description: 'automation-ui-action-features.action-features.formula.description',
  panelDescription: 'automation-ui-action-features.action-features.formula.panelDescription_cob',
  icon: 'serverlessFunction',
  theme: 'default',
  category: 'DATA_OPS',
  dataTestId: 'new-action-formula'
});

/**
 * Consolidated actions: One-to-many FE-to-BE actions.
 *
 * Prefix with ALL_ to indicate the one to many
 * relationship
 */

export const ALL_BRANCHES = new ActionMetadata({
  type: ActionTypes.ALL_BRANCHES,
  actionTypeBasePath: ActionTypeBasePaths.PLATFORM_FLOW_ALL_BRANCHES_ACTION,
  description: 'automation-ui-action-features.action-features.all-branches.description',
  panelDescription: 'automation-ui-action-features.action-features.all-branches.panelDescription_cob',
  icon: 'conditional',
  theme: 'default',
  category: 'QUICK_ACTIONS',
  dataTestId: 'new-action-all-branches'
});
export const ALL_DELAYS = new ActionMetadata({
  type: ActionTypes.ALL_DELAYS,
  actionTypeBasePath: ActionTypeBasePaths.PLATFORM_FLOW_ALL_DELAYS_ACTION,
  description: 'automation-ui-action-features.action-features.all-delays.description',
  panelDescription: 'automation-ui-action-features.action-features.all-delays.panelDescription_cob',
  icon: 'delay',
  theme: 'default',
  category: 'QUICK_ACTIONS',
  dataTestId: 'new-action-all-delays',
  subTypes: [ActionTypes.DELAY_UNTIL_DATE, ActionTypes.WAIT_UNTIL, ActionTypes.DELAY]
});